<template>
  <BreadCrumb PageTitle="Dashboard Recensement" />
  <RecensementDashboard />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import RecensementDashboard from "../../components/Dashboard/RecensementDashboard.vue";

export default defineComponent({
  name: "RecensementDashboardPage",
  components: {
    BreadCrumb,
    RecensementDashboard,
  },
});
</script>
